import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import imgGradimento from '../../assets/images/gradimento.jpg';
import { Link } from 'react-router-dom'
import { PAGINE } from "..";
import HeaderSenologia from "./components/HeaderSenologia";
import "./HomeSenologia.scss";
import PageContainer from "../../components/PageContainer";

const HomeGradimentoSenologia = ({ tipologia }) => {
    return <PageContainer tipologia={tipologia}>
            <Container className="bg-white p-0 pt-4 rounded">
                <HeaderSenologia />
                <Row>
                    <Col xs={12} md={6} className="d-flex flex-column justify-content-center mb-4">
                        <img src={imgGradimento} className="img-home-gradimento" alt="Modulo di Gradimento - InSenoAllaSalute" />
                        <div style={{ fontSize: '8px', textAlign: 'left' }}>
                            Foto di The Lazy Artist Gallery da Pexels
                        </div>
                    </Col>
                    <Col className="p-4 info-gradimento d-flex flex-column justify-content-center" xs={12} md={6}>
                        Gentile Signora,
                        <br /><br />
                        La ringraziamo per essersi rivolta alla nostra <strong>Breast Unit - Centro di Senologia Multidisciplinare</strong>
                        e Le chiediamo di dedicarci qualche minuto per capire se e come possiamo migliorare il servizio.
                        <div style={{ textAlign: 'center', marginTop: '4vh' }}>
                            <small>Il questionario è anonimo.</small>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col >
                        <nav className="text-center">
                            <Link to={`/${tipologia.URL}${PAGINE.MODULO_GRADIMENTO.URL}`} className="btn-inizia"><span>Inizia il</span><span style={{ color: 'hotpink' }}> questionario</span></Link>
                        </nav>
                    </Col>
                </Row>
                
            </Container>
        </PageContainer>
}

export default HomeGradimentoSenologia;